import { lastValueFrom } from 'rxjs';
import { consumeInternalLoginRedirect, isLoginPath } from '@shared/helpers/redirect.service';
import { SettingsState, SiteName } from '@shared/states/settings.state';

const WILCO_APP_STORE_URL = 'https://apps.apple.com/app/id6749717037';

function isIOS(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

function redirectToAppStoreIfNeeded(settingsState: SettingsState): void {
  // Always consume, so the marker never leaks into a later navigation in the same tab.
  const isInternalLoginRedirect = consumeInternalLoginRedirect();
  const isWilcoSite =
    settingsState.siteName === SiteName.Wilco || settingsState.siteName === SiteName.Preprod;

  if (isWilcoSite && isIOS() && isLoginPath() && !isInternalLoginRedirect) {
    window.location.replace(WILCO_APP_STORE_URL);
  }
}

export function initApp(settingsState: SettingsState) {
  return async (): Promise<void> => {
    await Promise.all([lastValueFrom(settingsState.loadSiteName())]);
    redirectToAppStoreIfNeeded(settingsState);
  };
}
